export default "__VITE_ASSET__OI2e_qyl__"